import React from "react";
import { Box, Typography } from "@mui/material";

const BenefitsFeature = ({
  number,
  title,
  mainDescription,
  description,
  image,
}) => {
  const words = title.split(" ");
  const lastWord = words.pop();
  const firstWords = words.join(" ");

  return (
    <>
      {/* Desktop and tablet — existing structure unchanged */}
      <Box
        className="autobet-benefit-card"
        sx={{ display: { xs: "none", sm: "flex" } }}
      >
        <Box className="autobet-benefit-card-bg" />

        <Box className="autobet-benefit-inner-wrapper">
          <Box className="autobet-benefit-number">
            {String(number).padStart(2, "0")}
          </Box>

          <Box className="autobet-benefit-content">
            <Typography
              component="p"
              className="autobet-benefit-label"
            >
              {title}
            </Typography>

            <Typography
              component="h3"
              className="autobet-benefit-title"
            >
              {title}
            </Typography>

            <Box className="autobet-benefit-title-line" />

            <Typography
              component="p"
              className="autobet-benefit-description"
            >
              {mainDescription}
            </Typography>

            <Box className="autobet-benefit-detail">
              <Box className="autobet-benefit-detail-dot" />
              <Typography component="p">
                {description}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box className="autobet-benefit-visual">
          <Box component="img" src={image} alt={title} />
        </Box>
      </Box>

      <Box
        className="autobet-benefit-card-mobile"
        sx={{ display: { xs: "flex", sm: "none" } }}
      >
        <Box className="autobet-benefit-mobile-header">
          <Typography
            component="p"
            className="autobet-benefit-mobile-label"
          >
            {title}
          </Typography>
        </Box>

        <Typography
          component="h3"
          className="autobet-benefit-mobile-title"
        >
          {firstWords}{" "}
          <Box component="span" className="autobet-benefit-mobile-title-highlight">
            {lastWord}
          </Box>
        </Typography>

        <Typography
          component="p"
          className="autobet-benefit-mobile-description"
        >
          {mainDescription}
        </Typography>

        <Box className="autobet-benefit-mobile-detail">
          <Box className="autobet-benefit-mobile-detail-dot" />
          <Typography component="p">
            {description}
          </Typography>
        </Box>
        
        <Box className="autobet-benefit-mobile-visual">
          <Box component="img" src={image} alt={title} />
        </Box>
      </Box>
    </>
  );
};

export default BenefitsFeature;